import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { OrderingForSale } from '../../interfaces/ordering/sale/orderingForSale';
import { OrderingPrePayment } from '../../interfaces/ordering/prePayment/orderingPrePayment';
import { OrderingForSaleService } from '../../services/orderingForSale.service';
import { PartialPaymentResult } from '../../interfaces/ordering/prePayment/partialPaymentResult';
import { OrderPaymentInfo } from '../../interfaces/ordering/prePayment/orderPaymentInfo';

export type OrderingForPrePaymentSaleState = {
  orderingForSale?: OrderingForSale | null;
  orderingPrePayment?: OrderingPrePayment | null;
  partialPayment?: PartialPaymentResult | null;
  infoPaymentOrder?: OrderPaymentInfo | null;
  error: boolean;
};

export type GetDataOrderingForPrePaymentSaleType = {
  orderingId: string;
  orderingPrePaymentId: string;
  url: string;
  getDataOrderingForSalePaymentUrl: string;
  getSumOrderingWithSumPaidPartialPaymentUrl: string;
  getInfoPaymentOrderByIdUrl: string;
};

const initialState: OrderingForPrePaymentSaleState = {
  orderingForSale: null,
  orderingPrePayment: null,
  partialPayment: null,
  infoPaymentOrder: null,
  error: false
};

export const getOrderingPrePayment = createAsyncThunk('ordering/orderingForPrePaymentSale', async (param: GetDataOrderingForPrePaymentSaleType) => { 
  const partialPaymentResult = await OrderingForSaleService.getSumOrderingWithSumPaidPartialPayment(param.getSumOrderingWithSumPaidPartialPaymentUrl, param.orderingId);
  
  const resultOrderingForSale = await OrderingForSaleService.getDataOrderingForSalePayment(param.orderingId, param.getDataOrderingForSalePaymentUrl);

  const resultOrderingPrePayment = await OrderingForSaleService.getOrderingPrePayment(param.url, param.orderingPrePaymentId);

  const resultInfoPaymentOrder = await OrderingForSaleService.getInfoPaymentOrderById(param.getInfoPaymentOrderByIdUrl, param.orderingId);

  return { resultOrderingForSale, resultOrderingPrePayment, partialPaymentResult, resultInfoPaymentOrder };
});

export const orderingForPrePaymentSaleSlice = createSlice({
  name: 'orderingForPrePaymentSale',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrderingPrePayment.fulfilled, (state, { payload }) => {
      state.orderingForSale = payload.resultOrderingForSale;
      state.orderingPrePayment = payload.resultOrderingPrePayment;
      state.partialPayment = payload.partialPaymentResult;
      state.infoPaymentOrder = payload.resultInfoPaymentOrder;
    }).addCase(getOrderingPrePayment.rejected, (state) => {
      state.error = true;
    }).addCase(getOrderingPrePayment.pending, (state) => {
      state.error = false;
    });
  }
});

export default orderingForPrePaymentSaleSlice.reducer;